package one.healthium.paywall.ui.components

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.base.utils.current
import one.healthium.base.utils.default
import one.healthium.domain.paywall.models.PaywallEmptyView

@Composable
fun PaywallEmptyView(model: PaywallEmptyView) {
    val config = model.configs.current()?.value ?: model.configs.default()?.value ?: return
    Spacer(Modifier.height(config.dp))
}
